export default __webpack_public_path__ + "static/national-yards-mobile-2e563570dc3c11c594d2f785203cfbad.svg";